function scrollAnim(targetElement, triggerElement, duration, offset, params) {
	if (typeof targetElement === 'string') {
		targetElement = $(targetElement)[0];
	}
	if (typeof triggerElement === 'string') {
		triggerElement = $(triggerElement)[0];
	}
	if (targetElement && triggerElement) {

		var scene =	new ScrollMagic.Scene(
			{
				triggerElement: triggerElement,
				duration: duration,
				offset: offset
			}
		)
			.setTween(TweenMax.to(targetElement, 1, params))
			.addTo(scrollController);
		return scene;
	}
}
